import { FC, memo } from "react";
import { PRODUCT_SLUG } from "@types";
import MobileCourseSwiper from "./MobileCourseSwiper";
import DesktopCourseSwiper from "./DesktopCourseSwiper";
import { ICardTab } from "types/card-tab";

interface propTypes {
  slug: PRODUCT_SLUG;
  activeTab: ICardTab | null;
  onReachEnd?: () => void;
  isLoading?: boolean;
  loadingMore?: boolean;
  firstLoad?: boolean;
  loadedProduct?: boolean;
}

const CourseSwiper: FC<propTypes> = (props) => {
  return (
    <>
      <div className="block lg:hidden w-full">
        <MobileCourseSwiper {...props} />
      </div>

      <div className="hidden lg:block w-full">
        <DesktopCourseSwiper {...props} />
      </div>
    </>
  );
};

export default memo(CourseSwiper);
